import styled from 'styled-components';

export const QueryBuilderStylesContainer = styled.div`
    .ruleGroup {
        border-color: #D9D9D9;
        background-color: rgba(0, 21, 41, .2)
    }
`;